import { COLORS } from 'helpers/globals'

const star = {
  color: COLORS.gold,
  fontSize: '2rem',
  marginLeft: '.7rem'
}

const listItem = {
  padding: '0 .7rem',
  lineHeight: '3.6rem',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center'
}

export default {
  CameraList: {
    color: COLORS.primary,
    flex: 1,
    borderTop: '5px solid'
  },
  list: {
    fontSize: '2rem',
    overflowY: 'auto'
  },
  listItemOdd: {
    ...listItem,
    background: 'white !important',
    overflow: 'hidden'
  },
  listItemEven: {
    ...listItem,
    background: `${COLORS.tertiary} !important`,
    overflow: 'hidden'
  },
  selected: {
    ...listItem,
    color: 'black',
    background: 'rgba(66, 139, 202, 0.6) !important',
    overflow: 'hidden'
  },
  NoMatch: {
    marginTop: '2rem',
    textAlign: 'center',
    fontSize: '1.9rem',
    color: 'black',
    position: 'relative',
    height: '100%'
  },
  cameraText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1
  },
  star,
  clock: {
    ...star,
    color: COLORS.secondary
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/CameraList/style.js